import { render, staticRenderFns } from "./SwabSampleAnalysisTableHeader.vue?vue&type=template&id=2b82d448&scoped=true&"
import script from "./SwabSampleAnalysisTableHeader.vue?vue&type=script&lang=ts&"
export * from "./SwabSampleAnalysisTableHeader.vue?vue&type=script&lang=ts&"
import style0 from "./SwabSampleAnalysisTableHeader.vue?vue&type=style&index=0&id=2b82d448&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b82d448",
  null
  
)

export default component.exports